import { useState } from "react";
import PropType from "prop-types";
import { useTranslate } from "../../../language/i18n";
import { Button, THEME } from "@myloc/myloc-gui";
import { myloc } from "../../../config/settings";
import { ExternalLink, Type } from "../Link";
import Modal from "./Modal";
import styles from "./ConfirmModal.module.scss";

function ConfirmModal({
  title,
  text,
  visible,
  cancel,
  submit,
  children,
  small = true,
  customCssClass,
  showButtons = true,
  showCloseButton,
  showConfirmButton = true,
  showDeclineButton = true,
  confirmButtonText,
  confirmButtonDisabled,
  declineButtonText,
  showSupportEmail = false,
}) {
  const translate = useTranslate();
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Modal
      title={translate(title)}
      visible={visible}
      onClose={cancel}
      small={small}
      customCssClass={customCssClass}
      showCloseButton={showCloseButton}
    >
      <p>
        {translate(text)}{" "}
        {showSupportEmail && (
          <ExternalLink url={myloc.supportEmail} type={Type.EMAIL}>
            {myloc.supportEmail.toString}
          </ExternalLink>
        )}
      </p>
      {children}
      {showButtons && (
        <footer className={styles.buttons}>
          {showDeclineButton && (
            <Button theme={THEME.SECONDARY} onClick={cancel}>
              {translate(declineButtonText ? declineButtonText : "NO")}
            </Button>
          )}
          {showConfirmButton && (
            <Button
              isLoading={isLoading}
              disabled={confirmButtonDisabled}
              onClick={() => {
                setIsLoading(true);
                submit().then(() => {
                  setIsLoading(false);
                  cancel();
                });
              }}
            >
              {translate(confirmButtonText ? confirmButtonText : "YES")}
            </Button>
          )}
        </footer>
      )}
    </Modal>
  );
}

ConfirmModal.propTypes = {
  title: PropType.string,
  text: PropType.string,
  visible: PropType.bool,
  cancel: PropType.func,
  submit: PropType.func,
  children: PropType.node,
  small: PropType.bool,
  customCssClass: PropType.string,
  showButtons: PropType.bool,
  showCloseButton: PropType.bool,
  showConfirmButton: PropType.bool,
  showDeclineButton: PropType.bool,
  confirmButtonText: PropType.string,
  confirmButtonDisabled: PropType.bool,
  declineButtonText: PropType.string,
  showSupportEmail: PropType.bool,
};

export default ConfirmModal;
